module.exports = __webpack_public_path__ + "img/text.0e238c97.png";